import { Card, CardContent, CardHeader, CardTitle } from '@travellegacy/nexops-design-system';
import { TrendingUp } from 'lucide-react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { formatTimeSaved } from '@/shared/lib/utils';

interface TimeSavedTrendChartProps {
  data?: Array<{ month: string; timeSaved: number }>;
}

export function TimeSavedTrendChart({ data: trendData }: TimeSavedTrendChartProps) {
  // Não precisa mais de loading state - recebe dados via props

  // Dados já vêm no formato correto "MM/YYYY"
  const chartData =
    trendData?.map((item: { month: string; timeSaved: number }) => ({
      name: item.month,
      timeSaved: item.timeSaved,
    })) || [];

  // Tooltip customizado para mostrar tempo formatado
  const CustomTooltip = ({
    active,
    payload,
  }: {
    active?: boolean;
    payload?: Array<{ value: number; payload: { name: string } }>;
  }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{payload[0].payload.name}</p>
          <p className="text-sm text-emerald-600 dark:text-emerald-400">
            Tempo: {formatTimeSaved(payload[0].value)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <TrendingUp className="mr-2 h-5 w-5" />
          Tempo Economizado (Últimos 6 meses)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="timeSaved"
              stroke="#10b981"
              strokeWidth={2}
              dot={{ fill: '#10b981', r: 4 }}
              activeDot={{ r: 6 }}
              name="Tempo Economizado"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
